export default {
  data() {
    return {
      visible: this.isVisible(),
    };
  },
  methods: {
    isVisible() {
      return (window.scrollY > 250);
    },
    scrollTop() {
      this.intervalId = setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.intervalId);
        }
        window.scroll(0, window.pageYOffset - 20);
      }, 5);
    },
    // "Слушает" бегунок и определяет показывать ли кнопку перемотки наверх или нет.
    scrollListener() {
      this.visible = this.isVisible();
    },
  },
  mounted() {
    window.addEventListener('scroll', this.scrollListener);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollListener);
  },
};
